<template>
  <div class="shopping-car">
    <div class="main-width page-inner">
      <div class="page-inner-header">
        <div class="page-inner-title">采购车</div>
      </div>
      <div style="margin-bottom:10px;">全部商品 {{amoutAll}}</div>
      <div v-if="records.length">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th style="width:135px;">品牌</th>
              <th>商品名称</th>
              <th style="min-width:80px">商品状态</th>
              <th style="min-width:80px">商品货号</th>
              <th style="min-width:80px">单价(元)</th>
              <th style="min-width:140px" class="text-center">调整</th>
              <th style="min-width:80px">数量</th>
              <th style="min-width:100px">小计(元)</th>
              <th style="min-width:80px">操作</th>
            </tr>
          </thead>
          <tbody v-for="group in this.records" :key="group.brandId" style="border-top:1px">
            <tr class="group-item">
              <td colspan="7" class="border-right-none border-left-none">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" v-model="group.checked" />
                  <label class="custom-control-label" @click="checkGroupAll(group)">
                    <strong>{{group.brandName}}</strong>
                  </label>
                </div>
              </td>
              <td class="border-right-none" style="color:#f03">{{subtotal(group.brandId) | toMoney}}</td>
              <td class="border-right-none"></td>
            </tr>
            <tr class="item" v-for="it in group.items" :key="it.id" :class="{active:$options.filters.getStatus(it)!='可下单'}">
              <td class="border-right-none">
                <div class="custom-control custom-control-inline custom-control-nolabel custom-checkbox" v-if="$options.filters.getStatus(it)=='可下单'">
                  <input type="checkbox" class="custom-control-input" v-model="it.checked" />
                  <label class="custom-control-label" @click.stop="itemCheck(it, group)"></label>
                </div>
                <div class="img-wrap">
                  <router-link target="_blank" :to="'/sku/'+it.commodityId">
                    <img class="img" v-if="it.pictureUri" :src="getImgUrl(it.pictureUri)" />
                    <img class="img" v-else src="@assets/images/no_image.png" />
                  </router-link>
                </div>
              </td>
              <td class="border-right-none">
                <router-link target="_blank" :to="'/sku/'+it.commodityId">
                  <div>{{it.commodityName}}</div>
                </router-link>
              </td>
              <td class="border-right-none">
                <div>{{it | getStatus}}</div>
              </td>
              <td class="border-right-none">
                <div>{{it.productNumber}}</div>
              </td>
              <td class="border-right-none">{{it.unitPrice | toMoney}}</td>
              <td class="border-right-none">
                <span>{{it.layQty}}&nbsp;x&nbsp;</span>
                <InputNumber :min="1" :value.sync="it.quantity" :scope="it" @change="changeQty(it.id, it.quantity)"></InputNumber>
              </td>
              <td class="border-right-none" style="color:#f03">{{it.layQty * it.quantity}}</td>
              <td class="border-right-none" style="color:#f03">{{multiply(it.unitPrice, it.layQty * it.quantity) | toMoney}}</td>
              <td>
                <button class="btn btn-secondary btn-xs" @click="remove(it.id)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else style="text-align:center;height:250px;padding:80px;">
        <span style="font-size:40px;">您的采购车是空的。</span>
      </div>
      <div class="clearfix summary">
        <div class="float-left" style="padding:20px 30px 0 12px">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" v-model="checkAll" />
            <label class="custom-control-label" @click="checkAllHandler">全选</label>
          </div>
        </div>
        <div class="float-left" style="padding:10px 0 0" v-show="records.length">
          <button type="button" class="btn btn-link" @click="removeChecked()">删除选中产品</button>
        </div>
        <div class="float-right">
          <span>已选 {{amoutChecked}}件 商品</span>
          <span>
            总价：
            <strong>￥{{selectMoney | toMoney}}</strong>
          </span>
          <button :class="(amoutChecked > 0) ? '':'default-button'" class="ap-btn ap-btn-darkred" @click="shoppingCheck">下单</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputNumber from "@components/InputNumber.vue";
import * as localStorage from "@common/localStorage";
import * as utils from "@common/utils";

export default {
  components: {
    InputNumber
  },
  data() {
    return {
      checkAll: false,
      records: []
    };
  },
  created() {
    this.getData();
    document.title = "51 AUTOPARTS 采购车";
  },
  computed: {
    selectMoney() {
      let result = 0;
      this.records.forEach(x =>
        x.items.forEach(y => {
          if (y.checked) result += this.multiply(y.unitPrice, y.layQty * y.quantity);
        })
      );
      return result;
    },
    amoutAll() {
      let result = 0;
      this.records.forEach(x => x.items.forEach(y => (result += y.layQty * y.quantity)));
      return result;
    },
    amoutChecked() {
      let result = 0;
      this.records.forEach(x =>
        x.items.forEach(y => {
          if (y.checked) result += y.layQty * y.quantity;
        })
      );
      return result;
    }
  },
  methods: {
    getData() {
      this.$list("/bhome/carts/query")
        .then(res => {
          let brands = [];
          let results = [];
          res.forEach(r => {
            if (brands.indexOf(r.brandId) == -1) brands.push(r.brandId);
          });
          brands.forEach(x => {
            let obj = {};
            let itemsList = [];
            res.forEach(r => {
              if (r.brandId == x) {
                r.checked = false;
                itemsList.push(r);
              }
            });
            obj.brandId = x;
            obj.brandName = itemsList[0].brandName;
            obj.items = itemsList;
            obj.checked = false;
            results.push(obj);
          });
          this.records = results;
        })
        .catch(err => {});
    },
    changeQty(id, qty) {
      this.$post("/bhome/carts/changeQty", { id: id, qty: qty })
        .then(res => {})
        .catch(err => {});
    },
    checkAllHandler() {
      this.checkAll = !this.checkAll;
      this.records.forEach(it => {
        it.checked = this.checkAll;
        it.items.forEach(it2 => {
          if (it2.archived || it2.publishState !== "PUBLISHED" || it2.supply === false) return; // 归档，下架，不可供应就不选中
          it2.checked = this.checkAll;
        });
      });
    },
    checkGroupAll(group) {
      group.checked = !group.checked;
      group.items.forEach(it => {
        if (it.archived || it.publishState !== "PUBLISHED" || it.supply === false) return; // 归档，下架，不可供应就不选中
        it.checked = group.checked;
      });
      if (this.records.every(it => it.checked)) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    itemCheck(it, group) {
      it.checked = !it.checked;
      if (!it.checked) {
        group.checked = false; // 只要有一个未选就是没有全选
        this.checkAll = false;
      } else {
        let groupCheckStatus = group.items.every(it => {
          if (it.archived || it.publishState !== "PUBLISHED" || it.supply === false) return true;
          if (it.checked) return true;
        });
        if (groupCheckStatus) group.checked = true;
        let allCheckStatus = this.records.every(it => {
          if (it.archived || it.publishState !== "PUBLISHED" || it.supply === false) return true;
          if (it.checked) return true;
        });
        if (allCheckStatus) this.checkAll = true;
      }
    },
    shoppingCheck() {
      if (this.amoutChecked < 1) return;
      let list = this.records.filter(x => {
        x.items = x.items.filter(y => y.checked == true); // 找出选中的商品
        if (x.items.length > 0) return x;
      });
      localStorage.write("cart", list);
      this.$router.push("/shoppingCheck");
    },
    subtotal(brandId) {
      let brandGroup = this.records.filter(x => x.brandId == brandId);
      let result = 0;
      brandGroup[0].items.forEach(x => {
        if (x.checked) {
          result += this.multiply(x.unitPrice, x.layQty * x.quantity);
        }
      });
      return result;
    },
    remove(id) {
      this.records = this.records.filter(x => {
        x.items = x.items.filter(y => y.id != id);
        if (x.items.length > 0) {
          return x;
        }
      });
      this.$post("/bhome/carts/destroy", { ids: [id] })
        .then(res => {})
        .catch(err => {});
    },
    removeChecked() {
      let ids = [];
      this.records = this.records.filter(x => {
        x.items = x.items.filter(y => {
          if (y.checked == false) {
            return y;
          } else {
            ids.push(y.id);
          }
        });
        if (x.items.length > 0) {
          return x;
        }
      });
      if (ids.length > 0) {
        this.$post("/bhome/carts/destroy", { ids: ids })
          .then(res => {
            this.checkAll = false;
          })
          .catch(err => {});
      }
    },
    multiply(arg1, arg2) {
      return utils.multiply(arg1, arg2);
    }
  },
  filters: {
    getStatus(it) {
      if (it.archived) return "已归档";
      if (it.publishState !== "PUBLISHED") return "已下架";
      if (it.supply === false) return "不可供应";
      return "可下单";
    }
  }
};
</script>

<style lang="less">
.shopping-car {
  padding: 12px 0;
  background: #f2f2f2;
  .img-wrap {
    float: right;
    width: 82px;
    height: 82px;
    .img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  thead {
    background: #f2f2f2;
    th {
      border-color: #f2f2f2;
    }
  }
  .group-item {
    td {
      border-bottom: 2px solid #ccc;
    }
  }
  .item {
    &.active {
      color: #ccc;
    }
    &:hover {
      background: #f2f2f2;
      .border-right-none {
        border-right-color: #f2f2f2 !important;
      }
    }
  }
  .summary {
    margin-top: 40px;
    background: #f2f2f2;
    span,
    button {
      display: inline-block;
      vertical-align: middle;
    }
    span {
      margin: 0 30px;
    }
    strong {
      color: #f03;
      font-size: 18px;
    }
    .default-button {
      background: #ccc;
      &:hover {
        background: #ccc;
      }
    }
    .ap-btn-darkred {
      width: 150px;
      padding: 15px 0;
      font-size: 20px;
      font-weight: bold;
      &:hover {
        font-weight: normal;
      }
    }
  }
}
</style>
